import { contact } from '../data/site';
import { trackWhatsAppClick } from '../lib/analytics';
import { WhatsAppIcon } from './icons';

/**
 * Sticky WhatsApp call-to-action, fixed to the bottom-right on every screen so
 * guests can reach us from anywhere on the page.
 */
export function WhatsAppButton() {
  return (
    <a
      href={contact.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick('floating_button')}
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-card ring-1 ring-black/5 transition-transform duration-300 hover:scale-110 sm:bottom-7 sm:right-7"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-40 group-hover:opacity-0" />
      <WhatsAppIcon className="relative h-7 w-7" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
